// add easeOutExpo
$.extend( $.easing,
	{
		easeOutExpo : function( e, a, b, c, d ) {
			return a==d?b+c:c*(-Math.pow(2,-10*a/d)+1)+b
		}
	}
);